import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/Resources.css";

import {
  recentBlogs,
  mostRead,
  trendingNews,
  campusNews,
  aroundSchool,
  featuredBlogs,
} from "../data/resourcesData";

export default function Resources() {
  const [activeTag, setActiveTag] = useState("All");

  const RESOURCE_SECTIONS = [
    {
      title: "Featured Blogs",
      link: "/featured-blogs",
      data: featuredBlogs,
      type: "blog",
    },

    {
      title: "Recent Blogs",
      link: "/recent-blogs",
      data: recentBlogs,
      type: "blog",
    },

    {
      title: "Trending News",
      link: "/trending-news",
      data: trendingNews,
      type: "news",
    },

    {
      title: "Campus News",
      link: "/campus-news",
      data: campusNews,
      type: "news",
    },

    {
      title: "Videos",
      link: "/videos",
      data: aroundSchool,
      type: "video",
    },
  ];

  return (
    <div className="res-page">
      {}

      <section className="res-hero">
        <h1>Resources</h1>

        <p>
          Explore latest blogs, campus updates, student stories, educational
          insights and videos from Sahara Public Secondary School.
        </p>
      </section>

      {}

      {RESOURCE_SECTIONS.map((section, index) => (
        <section className="wrap resource-block" key={index}>
          <div className="resource-heading-row">
            <h2>{section.title}</h2>

            <Link to={section.link} className="btn btn-primary">
  View All
</Link>
          </div>

          <div className="res-grid">
            {section.data.slice(0, 3).map((item, i) => (
              <div className="res-card" key={i}>
                <img
                  src={item.image || item.thumbnail}

                  alt={item.title}
                />

                <div className="res-card-body">
                  <span className="res-card-tag">
                    {item.category || item.tags || "School"}
                  </span>

                  <h3>{item.title}</h3>

                  <p>
                    {item.excerpt ||
                      "Explore latest updates and educational insights from Sahara Public School."}
                  </p>

                  <div className="res-card-meta">
                    <span>{item.author || "Sahara Team"}</span>

                    <span>{item.date || "2026"}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      ))}

      {}

      <section className="res-most-read">
        <div className="wrap">
          <h2>Most Read</h2>

          <div className="res-most-read-grid">
            {mostRead.slice(0, 4).map((item, index) => (
              <Link
                to="/most-read"

                className="res-most-read-card"

                key={index}
              >
                {item.title || item}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
